export default __webpack_public_path__ + "static/media/stock3.898c8054.png";